export const TAGS = {
  BASE_PROJECT_CASES: 'base_project_cases',
  CHAT_MESSAGES: 'chat_messages',
  COOPERATIVE_COMMON_CASES: 'cooperative_common_cases',
  COOPERATIVE_SPACE_RENOVATION_REQUESTS:
    'cooperative_space_renovation_requests',
  COOPERATIVE_SPACES: 'cooperative_spaces',
  DOCUMENTS: 'documents',
  DOCUMENTS_LIST: 'documents_list',
  EVENTS_LIST: 'events_list',
  FISCAL_YEARS: 'fiscal_years',
  INVOICES: 'invoices',
  KEY_ORDERS: 'key_orders',
  LOTS: 'lots',
  MASS_MESSAGES: 'mass_messages',
  TASKS: 'tasks',
  NEWSLETTERS: 'newsletters',
  USER_COMMON_CASES: 'user_common_cases',
  USER_SPACE_RENOVATION_REQUESTS: 'user_space_renovation_requests',
} as const;
